import { goToPlace } from 'utils/navigation';

export function redirectToWorkflows() {
  goToPlace('WorkflowListPlace:/');
}

export function getWorkflowNameErrorMessageId(name = '') {
  if (name.indexOf('\\') >= 0) {
    return 'BACK_SLASHES_NOT_ALLOWED';
  }
  if (name.indexOf('/') >= 0) {
    return 'FORWARD_SLASHES_NOT_ALLOWED';
  }
  return null;
}

export function getIsLogging(loggingLevel) {
  return loggingLevel !== 'ERROR';
}

export function getLoggingLevel(isLogging) {
  return isLogging ? 'INFO' : 'ERROR';
}

export function getPackageUrl(featureToggleMap, packageUrl) {
  return typeof packageUrl === 'string'
    ? packageUrl
    : packageUrl(featureToggleMap);
}
